


















































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Nav from "@/components/nav/navBar.vue";
import * as types from "@/store/constants/types";
import VideoPlayer from "@/components/videoPlayer/videoPlayer.vue";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
    Nav,
    VideoPlayer
  }
})
export default class SuperPayPaymentClose extends Vue {
  @Action(types.START_INSTALL_SUPER_PAY_APP)
  private installSuperPayApp: any;
  @Getter(types.GETTER_SUPER_PAY_PARAMS)
  private superPayAppParams: any;
  @Action(types.FETCH_VIDEO_URL_BY_DICT)
  private getVideoURL: any;
  @Getter(types.GETTER_SUPER_PAY_APP_DESC_LIST)
  private superPayAppDescList: any;
  @Getter(types.GETTER_SUPER_PAY_APP_DESC)
  private superPayAppDesc: any;

  private videoSrc: string = "";

  get list() {
    return this.superPayAppDescList();
  }

  get poster() {
    return require("@/assets/icons-file/super_pay/super_video_face.png");
  }

  private created() {}

  private async mounted() {
    this.videoSrc = await this.getVideoURL(
      this.superPayAppParams.video_files.payment_close_retain
    );

    sendEventWithParams("uia_recommend_app_show", {
      super_pay: "payment_close"
    });
  }

  @Emit("clickClose")
  private clickClose(): void {
    console.log("clickClose");
  }

  private clickGet() {
    //自行在组件内触发：
    this.installSuperPayApp({
      ga: "payment_close"
    });
    this.$emit("clickClose");
  }
}
